import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/procedureService";

export const fetchProcedures = createAsyncThunk("procedures/fetchAll", async (params) => {
  const res = await svc.getProcedures(params);
  return res.data;
});

export const createProcedureThunk = createAsyncThunk("procedures/create", async (data) => {
  const res = await svc.createProcedure(data);
  return res.data;
});

export const updateProcedureThunk = createAsyncThunk("procedures/update", async ({ id, data }) => {
  const res = await svc.updateProcedure(id, data);
  return res.data;
});

export const deleteProcedureThunk = createAsyncThunk("procedures/delete", async (id) => {
  await svc.deleteProcedure(id);
  return id;
});

const procedureSlice = createSlice({
  name: "procedures",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcedures.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchProcedures.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchProcedures.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createProcedureThunk.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updateProcedureThunk.fulfilled, (state, action) => {
        const idx = state.list.findIndex((p) => p.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteProcedureThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((p) => p.id !== action.payload);
      });
  },
});

export default procedureSlice.reducer;
